import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ShieldCheck } from 'lucide-react';
import privaxiaLogo from '@/assets/privaxia-logo.png';

const LoginPage = () => {
  const navigate = useNavigate();
  
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex">
      <div 
        className="hidden lg:flex lg:w-1/2 bg-cover bg-center relative"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1765366417030-16d9765d920a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBkYXRhJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzY4OTk3NjY2fDA&ixlib=rb-4.1.0&q=85)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#0F172A]/90 to-[#0F172A]/70" />
        <div className="relative z-10 flex flex-col justify-center items-start p-12 text-white">
          <img src={privaxiaLogo} alt="Privaxia Logo" className="w-20 h-20 object-contain mb-6" />
          <h1 className="text-5xl font-bold mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Conformidade RGPD Simplificada
          </h1>
          <p className="text-xl text-slate-300 max-w-md">
            Gestão profissional de consentimentos e compliance com o Regulamento Geral sobre a Proteção de Dados.
          </p>
        </div>
      </div>
      
      <div className="flex-1 flex items-center justify-center p-8 bg-slate-50">
        <div className="w-full max-w-md space-y-8">
          <div className="text-center">
            <div className="flex items-center justify-center mb-6">
              <img src={privaxiaLogo} alt="Privaxia Logo" className="w-16 h-16 object-contain" />
            </div>
            <h2 className="text-3xl font-bold text-[#0F172A]" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Privaxia
            </h2>
            <p className="mt-2 text-sm text-slate-600">
              Plataforma de Gestão de Consentimentos RGPD
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-sm border border-slate-200">
            <div className="space-y-6">
              <div className="text-center space-y-2">
                <h3 className="text-lg font-semibold text-[#0F172A]">
                  Bem-vindo
                </h3>
                <p className="text-sm text-slate-600">
                  Inicie sessão para aceder à plataforma de compliance
                </p>
              </div>

              <Button
                data-testid="google-login-button"
                onClick={handleLogin}
                className="w-full h-12 bg-[#0F172A] hover:bg-[#0F172A]/90 text-white font-medium"
              >
                <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Continuar com Google
              </Button>
              
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <span className="w-full border-t border-slate-200" />
                </div>
                <div className="relative flex justify-center text-xs uppercase">
                  <span className="bg-white px-2 text-slate-500">ou</span>
                </div>
              </div>
              
              <Button
                data-testid="local-login-link"
                variant="outline"
                onClick={() => navigate('/login-local')}
                className="w-full h-12 border-slate-300 text-[#0F172A] hover:bg-slate-50"
              >
                Entrar com Email e Password
              </Button>

              <div className="text-xs text-center text-slate-500">
                Ao continuar, concorda com os nossos termos de serviço e política de privacidade conforme RGPD.
              </div>
            </div>
          </div>

          <div className="text-center text-xs text-slate-500">
            © 2026 Privaxia. Todos os direitos reservados.
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;